<template lang="html">
    <el-button
        type="primary"
        @click="logout">
        Déconnexion
    </el-button>
</template>

<script>
export default {
    name: 'ButtonLogout',
    methods: {
        logout () {
            this.$store.dispatch('logoutUser').then((result)=>{
                this.$store.commit('UNSET_CURRENT_SITE')
                this.$router.push('/');
            });
        }
    }
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/page/Account/ButtonLogout.vue